import { useCallback, useState } from 'react';

import type { IPinAccessGuard } from './PinManagement.helpers';
import VerifyPassword from './VerifyPassword';

const PinAccessGuard = ({ children, skip }: IPinAccessGuard) => {
	const [isPasswordVerified, setIsPasswordVerified] = useState<boolean>(false);

	const onPasswordVerified = useCallback(() => {
		setIsPasswordVerified(true);
	}, []);

	return (
		<>
			{!isPasswordVerified && !skip ? (
				<VerifyPassword onPasswordVerified={onPasswordVerified} />
			) : (
				<div className='subbodycontent_main'>{children}</div>
			)}
		</>
	);
};

export default PinAccessGuard;
